module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_f_albino.3be6da46.png";